import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Reminders_GetReminders, Reminders_InsertEditReminder, Reminders_DeleteReminder } from '../../../Services/Actions';
import moment from 'moment';

import { BuildRecurrencePattern, GetWeekdaysFromRecurrencePattern } from '../../../Functions';

import TimePicker from 'rc-time-picker';
import { toast } from 'react-toastify';

import * as styles from './styles';

import ButtonGroup from '../../Buttons/ButtonGroup';
import Loading from '../../Loading';
import PageText from '../../Text/PageText';
import Spacer from '../../Spacer';
import Toggle from '../../Form/Toggle';

var DAYS_OF_THE_WEEK = [
    { DayAbbr: 'MO', DayName: 'Monday' },
    { DayAbbr: 'TU', DayName: 'Tuesday' },
    { DayAbbr: 'WE', DayName: 'Wednesday' },
    { DayAbbr: 'TH', DayName: 'Thursday' },
    { DayAbbr: 'FR', DayName: 'Friday' },
    { DayAbbr: 'SA', DayName: 'Saturday' },
    { DayAbbr: 'SU', DayName: 'Sunday' }
];

class RemindersPage extends React.Component {
    state = {
        DailyReminder: {
            Days: [],
            DueAt: '',
            ReminderId: 0,
            Status: null
        },
        Reminders: [],

        DueAt: null,
        ReminderType: null,
        UserId: null,
        ReminderMessage: '',
        
        Loading: true
    }

    componentDidMount() {
        this.setState({ UserId: this.props.UserId }, this.onGetReminders);
    }

    handleChangeTime = DueAt => {
        // console.log('utc: ', moment.utc(DueAt))
        var DailyReminder = { ...this.state.DailyReminder };
        DailyReminder.DueAt =  moment(DueAt);

        this.setState({ DailyReminder });
    }

    handleDailyReminderToggle = event => {
        var Status = 'INACTIVE';

        if (event.target.checked) Status = 'ACTIVE';

        var DailyReminder = { ...this.state.DailyReminder };
        DailyReminder.Status = Status;

        this.setState({ DailyReminder }, () => {
            var { DailyReminder: { ReminderId }, UserId } = this.state;

            if (+ReminderId !== 0) {
                if (Status === 'INACTIVE') this.props.Reminders_DeleteReminder({ ReminderId, UserId }).then(() => {
                    toast.success(this.props.t('daily_reminder_updated'), {
                        position: "bottom-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
        
                    this.onGetReminders();
                });
                else if (DailyReminder.Days.length > 0) this.onInsertEditDailyReminder();
            }
        });
    }

    handleDaySelect = (dayAbbr, isChecked) => {
        var DailyReminder = { ...this.state.DailyReminder };
        var Days = [ ...DailyReminder.Days ];

        if (isChecked) Days = [ ...Days, dayAbbr ]
        else Days = Days.filter(day => day !== dayAbbr);

        DailyReminder.Days = Days;

        this.setState({ DailyReminder });
    }

    onGetReminders = () => {
        var { UserId } = this.state;

        this.props.Reminders_GetReminders({ UserId }).then(({ Reminders }) => {
            var { DailyReminder, Other } = Reminders;
            DailyReminder.Days = GetWeekdaysFromRecurrencePattern(DailyReminder.RecurrencePattern);

            this.setState({ Loading: false, DailyReminder, Reminders: Other });
        })
    }

    onInsertEditDailyReminder = () => {
        var { Days, DueAt } = this.state.DailyReminder;
        var { UserId } = this.state;

        DueAt = new Date(DueAt);

        // Set DueAt date to be today so any changes will reset the next due date
        var now = new Date();
        DueAt.setYear(now.getFullYear());
        DueAt.setMonth(now.getMonth());
        DueAt.setDate(now.getDate());

        DueAt = moment.utc(DueAt).seconds(0).milliseconds(0);

        var RecurrencePattern = BuildRecurrencePattern({ ByWeekDay: Days, DueAt, Freq: 'weekly' });

        this.props.Reminders_InsertEditReminder({ DueAt, RecurrencePattern, ReminderType: 'DailyReminder', UserId }).then(() => {
            toast.success(this.props.t('daily_reminder_updated'), {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            this.onGetReminders();
        });
    }

    renderDailyReminder = () => {
        var { t } = this.props;
        var { DailyReminder } = this.state;

        return (
            <styles.DailyReminderBox className="DailyReminderBox">
                <PageText FontFamily="semibold" FontSize="medium-2" JustifyContent="center" NoMargin Text={t('daily_reminder')} TextAlign="center" />

                <Spacer Size="small" />

                <Toggle
                    Checked={DailyReminder.Status === 'ACTIVE'}
                    OffLabel={t('off')}
                    OnChange={this.handleDailyReminderToggle}
                    OnLabel={t('on')}
                />

                <Spacer Size="small" />

                {
                    DailyReminder.Status === 'ACTIVE' &&
                    <>
                        <styles.DaysOfWeekBox className="DaysOfWeekBox">
                            {DAYS_OF_THE_WEEK.map(({ DayAbbr, DayName }, DayIndex) => {
                                const isSelected = DailyReminder.Days.includes(DayAbbr);

                                return (
                                    <styles.DayBox className="DayBox" key={DayIndex}>
                                        <styles.RadioButtonParentContainer className="RadioButtonParentContainer">
                                            <styles.PseudoCheckbox className="PseudoCheckbox" BackgroundColor="274775" onClick={() => this.handleDaySelect(DayAbbr, !isSelected)} Selected={isSelected} />

                                            <styles.RadioButtonPageText ElementType="span" FontFamily='medium' FontSize="medium-1" JustifyContent="flex-start" OnClick={() => this.handleDaySelect(DayAbbr, !isSelected)} Text={DayName} TextAlign="left" />
                                        </styles.RadioButtonParentContainer>
                                    </styles.DayBox>
                                );
                            })}
                        </styles.DaysOfWeekBox>

                        <Spacer Size="extra-small" />

                        <TimePicker
                            defaultValue={moment(DailyReminder.DueAt)}
                            minuteStep={5}
                            onChange={DateTime => this.handleChangeTime(DateTime)}
                            showSecond={false}
                            use12Hours={false}
                            value={moment(DailyReminder.DueAt)}
                        />

                        <Spacer Size="extra-small" />

                        <ButtonGroup
                            Buttons={[{ BackgroundColor: 'blue-abel', BackgroundColorHover: 'blue-abel-hover', Border: 'none', Color: 'white', ColorHover: 'white', FontFamily: 'semibold', OnClick: this.onInsertEditDailyReminder, Title: t('_save') }]}
                            ButtonWidth="fit-content"
                            NotTouching
                            OwnRows={false}
                        />
                    </>
                }
            </styles.DailyReminderBox>
        );
    }

    render() {
        if (this.state.Loading) return <Loading />;

        var { TryingRemindersAction } = this.props;

        return (
            <>
                {(TryingRemindersAction) && <Loading />}

                {/* <PageText FontFamily="medium" FontSize="large" NoMargin OnClick={() => console.log('this.state: ', this.state)} Text="Reminders" />

                <Spacer Size="medium" /> */}

                {this.renderDailyReminder()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        TryingRemindersAction: state.Reminders.TryingRemindersAction,
        TryingRemindersActionError: state.Reminders.TryingRemindersActionError
    };
};

export default withTranslation()(connect(mapStateToProps, { Reminders_GetReminders, Reminders_InsertEditReminder, Reminders_DeleteReminder } )(RemindersPage));